import styled from 'styled-components';
import { Box } from '@mui/material';
import {
  ActivityResponse,
  ClientResponse,
  PlanningEntityType
} from 'generated/index';
import { getClientName } from 'components/roster-portal/activity-planning/utils';

type Props = {
  planningEntityType: PlanningEntityType;
  activity?: ActivityResponse;
  client?: ClientResponse;
  isAbsent?: boolean;
  titleLineClamp: number;
  isSideDrawer?: boolean;
};

const Title = styled('h4')<{ lineclamp?: string | number; isAbsent?: boolean }>`
  overflow: hidden;
  display: -webkit-inline-box;
  line-height: 1.25;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lineclamp }) => lineclamp || 'initial'};
  text-overflow: ellipsis;
  font-family: SourceSans !important;
  font-size: 1.125em;
  text-decoration: ${({ isAbsent }) => (isAbsent ? 'line-through' : 'none')};
`;

const NameSection = ({
  planningEntityType,
  activity,
  client,
  isAbsent,
  titleLineClamp,
  isSideDrawer = false
}: Props) => {
  function getTitle() {
    if (planningEntityType === 'CLIENT') {
      return activity?.name ?? '';
    }
    return !client && activity ? activity.name : getClientName(client);
  }

  const title = getTitle();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: isSideDrawer ? '0' : '4px 0 4px 4px',
        marginRight: '8px'
      }}
    >
      <Title lineclamp={titleLineClamp} isAbsent={isAbsent}>
        {title}
      </Title>
    </Box>
  );
};

export default NameSection;
